<template lang='pug'>
div
    //- iframe(:src="previewUrl") 
    Pdf(v-if='previewUrl' :options='{source: previewUrl}' :title='title')
    .share.cover(v-show='isShare', @click='isShare = false')
        .content
    .button-group
        .button-item
            img(src='@/assets/imgs/download.png')
            div(@click='downloadPdf') 下载到手机
        .button-item
            img(src='@/assets/imgs/mail.png')
            div(@click='downloadMail') 发送到邮箱
        .button-item
            img(src='@/assets/imgs/share.png')
            div(@click='isShare = true') 立即分享
</template>

<script>
import { sleep } from '@/utils/common'
import { concatWithSymbol, documentview, downloadview, getDataRow, getPathNames, getSignatureUrl, updateWxShareData, concatURI } from '@custouch/proxy-use'
import { CHECK_UNIQUE_FORMID } from '@/configs/constants'
import Pdf from './components/Pdf.vue'
import { checkWechatUnique } from '@/service'
export default {
    props: ['rId','hId'],
    data() {
        return {
            pdf: {},
            pdfUrl: '',
            isShare: false,
            title: '',
            tagIds: []
        }
    },
    components: {
        Pdf
    },
    computed:{
        previewUrl(){
          const link = this.pdf.link
          if(!link) return ''
          return link.replace('download/','download/pdfviewer/')
        }
    },
    beforeRouteEnter(to,from,next){
        next(async(vm)=>{
            const [ret, res] = await Promise.all([getDataRow({dataRowId: vm.rId}), checkWechatUnique(CHECK_UNIQUE_FORMID)])
            if(res){
                let link = concatURI('https://form.cloud.custouch.com/show/737109750218719232',{
                    fileid: ret.id,
                    c_filename: ret.detail.name,
                    c_default_redirect: window.location.href
                })
                window.location.replace(link)
                next(false)
            }
        })
    },
    methods: {
        async downloadPdf() {
            // this.catchEvent('downloadview')
            this.$root.$emit('actionView', {
                type: 'downloadview',
                params: {
                    title: this.title,
                    name: this.pdf.name,
                    source: this.pdf.link,
                    tagIds: this.tagIds.join(',')
                }
            })
            await sleep(50)
            window.location.href = this.pdf.link
        },
        downloadMail() {
            window.location.href = `https://form.cloud.custouch.com/show/737107329295659008?fileid=${this.pdf.id}&c_filename=${encodeURIComponent(this.pdf.name)}&c_fileurl=${encodeURIComponent(this.pdf.link)}&c_default_redirect=${encodeURIComponent(window.location.href)}`
        },
        catchEvent(type) {
            this.$root.$emit('actionView', {
                type, params: {
                    name: this.pdf.name,
                    source: this.pdf.link
                }
            })
        }
    },
    async created() {
        const ret = await getDataRow({dataRowId: this.rId})
        this.pdfUrl = await getSignatureUrl(ret.detail.link)
        let title = concatWithSymbol([this.$route.meta.title,ret.detail.name])
        if(this.hId){
            title = await getPathNames(this.hId,ret.detail.name)
        }
        this.title = title
        this.tagIds = ret.tagIds
        this.pdf = ret.detail
        this.$root.$emit('pageview',{
            title,
            tagIds: ret.tagIds.join(',')
        })
        const { LOGO } = window.env
        updateWxShareData({
            title: ret.detail.name,
            desc: '点击查看详情',
            imgUrl: LOGO
        })
        // documentview({
        //     title,
        //     name: ret.detail.name,
        //     source: ret.detail.link
        // })
        // const data = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_DOCUMENT)
        // const { id } = this.$route.params
        // this.pdf = data.find(item => item.type === 'pdf' && item.id == id)
        // this.pdfUrl = await this.$store.dispatch('getSignatureUrl', this.pdf.link)
        // this.$updateWxShareData({
        //     title: this.pdf.name,
        //     description: '点击查看详情',
        //     image: window.location.href.split(/[?#]/)[0] + 'logo.jpg'
        // })
        // this.catchEvent('documentview')
    }
}
</script>

<style scoped lang='less'>
iframe{
    width: 100%;
    height: 100%;
    border: none;
}
.button-group {
    position: fixed;
    left: 0;
    bottom: 5%;
    z-index: 99;
    color: #0067b1;
    line-height: 1;
    display: flex;
    height: 1.6rem;
    align-items: center;
    padding: 0 1rem;
    justify-content: space-between;
    width: 100%;
}
.share {
    .content {
        background: url('https://oss.cloud.custouch.com/cus_files/custouch/site/image/share.png')
            no-repeat top/contain;
    }
}
.cover {
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);
    .content {
        width: 70%;
        height: 70%;
    }
}
</style>